// extracted by mini-css-extract-plugin
module.exports = {"button":"PortfolioLozenge_button__W7_ml","buttonActive":"PortfolioLozenge_buttonActive__Z9gYQ","dark":"PortfolioLozenge_dark__0zR7o"};